import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Checkbox,
  CheckboxGroup,
  Select,
  Tag,
} from "@stonelog/stonelog-design-system";
import { useSelector, useDispatch } from "react-redux";
import { setCenter, setZoom } from '../../../../../../../../../features/senninha/pinsSlice';
import { angelsSelector } from '../../../../../../../../../features/senninha/angelsSlice';
import { hubsSelector } from '../../../../../../../../../features/senninha/hubsSlice';
import { manageSelectedPredeliveryPins, manageSelectedRelocatePins, resetSelectedPreDeliveryPins, resetSelectedRelocatePins, resetUnassociatedPinAnyData, routesManagementSelector } from '../../../../../../../../../features/senninha/routesManagementSlice';
import AreaSelectControl from './AreaSelectControl';

import * as S from './styles';


const RelocateRoutes = ({
  setNewWorkFlow,
  checkedList,
  setCheckedList,
  setRoutes,
  isDeallocate = undefined
}) => {
  const dispatch = useDispatch()

  const {
    selectedHubInfos
  } = useSelector(hubsSelector);

  const {
    selectedRelocatePins
  } = useSelector(routesManagementSelector);

  const {
    angels,
    status
  } = useSelector(angelsSelector);

  const {
    unassociatedPinAnyData,
  } = useSelector(routesManagementSelector);

  const [selectedAngel, setSelectedAngel] = useState()
  const [checkboxOptions, setCheckboxOptions] = useState([])

  const isBlocked = !unassociatedPinAnyData.unassociatedPin
  const checkAll = checkboxOptions.length === checkedList.length && checkedList.length
  const indeterminate = checkedList.length > 0 && checkedList.length < checkboxOptions.length

  const getTotalOss = () =>
    selectedRelocatePins.reduce((sum, item) => sum + (item.oss?.length || 0), 0)
  
  // getTotalKits = filtra item.servico == ENVIO DE SUPRIMENTOS e soma item.tecnologias.length
  const getTotalKits = () =>
    selectedRelocatePins.reduce((sum, item) => {
      if (item.servico?.toLowerCase() === 'envio de suprimentos') {
        return sum + (item.tecnologias?.length || 0);
      }
      return sum;
    }, 0);

  const getAngelsOptions = () => angels.map(({ nome, document_number }) => ({
    value: document_number,
    label: nome
  }))

  const onChange = (list) => {
    const notCheckedPinsIds = checkboxOptions.filter((item) => checkedList.includes(item))
    notCheckedPinsIds.forEach((pinId) => {
      const pinData = unassociatedPinAnyData.deliveriesPins2BeAssociated.find((item) => item.id === pinId)
      const isSelected = selectedRelocatePins.find((item) => item.id === pinData.id)
      if (isSelected)
        dispatch(manageSelectedRelocatePins(pinData))
    })

    list.forEach((pinId) => {
      dispatch(manageSelectedRelocatePins(unassociatedPinAnyData.deliveriesPins2BeAssociated.find((item) => item.id === pinId)))
    })

    setCheckedList(list);
  };

  const onCheckAllChange = (e) => {
    setCheckedList(e.target.checked ? checkboxOptions : []);
    unassociatedPinAnyData.deliveriesPins2BeAssociated.forEach((item) => {
      if (!indeterminate || !checkedList.includes(item.id)) {
        dispatch(manageSelectedRelocatePins(item));
      }
    });
  };

  const handleSeeOnMapClick = (lat, lng) => {
    dispatch(setCenter({
      center: {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      }
    }))
    dispatch(setZoom(20))
  }

  const managePinRemoval = (pin) => {
    dispatch(manageSelectedRelocatePins(pin))
    dispatch(manageSelectedPredeliveryPins(pin))
    setCheckedList((p) => p.filter((item) => item.id === pin.id))
  }

  const handleSaveClick = () => {

    const pinsParaEnviar = selectedRelocatePins.filter(pin => {
      if (pin.id === 'polo-root') return false;

      const isFilhoDoPolo = unassociatedPinAnyData?.deliveriesPins2BeAssociated?.some(d => d.id === pin.id);
      if (isFilhoDoPolo) {
        return checkedList.includes(pin.id);
      }

      if (pin.servico?.toLowerCase() === 'coleta') {
        const hasSelectedEntregas = selectedRelocatePins.some((otherPin) => {
          if (otherPin.id === pin.id) return false;
          if (otherPin.servico?.toLowerCase() !== 'entrega') return false;

          if (pin.associatedPinsIDs?.includes(otherPin.id)) return true;

          if (pin.id_atendimento && otherPin.id_atendimento) {
            return Array.isArray(otherPin.id_atendimento)
              ? otherPin.id_atendimento.some((id) => pin.id_atendimento.includes(id))
              : pin.id_atendimento.includes(otherPin.id_atendimento);
          }

          return false;
        });
        if (hasSelectedEntregas) return false;
      }

      return true;
    });

    setRoutes((p) => {
      return [...p, {
        type: isDeallocate ? 'deallocation' : 'relocation',
        angel: angels?.find(({ document_number }) => document_number === selectedAngel),
        pins: pinsParaEnviar,
        ossAmount: pinsParaEnviar.reduce((sum, item) => sum + (item.oss?.length || 0), 0),
        polo: selectedHubInfos.children,
      }]
    });

    setNewWorkFlow(false);
    dispatch(resetSelectedRelocatePins());
    dispatch(resetSelectedPreDeliveryPins());
  };

  useEffect(() => {
    if (unassociatedPinAnyData.deliveriesPins2BeAssociated)
      setCheckboxOptions(unassociatedPinAnyData.deliveriesPins2BeAssociated.map(({ id }) => id))
  }, [unassociatedPinAnyData.deliveriesPins2BeAssociated])

  return (
    <S.RealocateContainer>
      {!isDeallocate &&
        <div>
          <Select
            label='Realocar para'
            placeholder='Selecione um Angel'
            options={getAngelsOptions()}
            value={selectedAngel}
            onChange={(v) => setSelectedAngel(v)}
            loading={status === 'pending'}
            size="small"
            showSearch
            optionFilterProp="label"
            className="ginga-select"
          />
        </div>
      }
      <AreaSelectControl />
      <S.RealocateInfos>
        <p>Total de pins selecionados</p>
        <span>{selectedRelocatePins?.length}</span>
      </S.RealocateInfos>
      <S.RealocateInfos>
        <p>Total de OS</p>
        <span>{getTotalOss()}</span>
      </S.RealocateInfos>
      <S.RealocateInfos>
        <p>Total de Kits</p>
        <span>{getTotalKits()}</span>
      </S.RealocateInfos>
      <S.RealocateTags>
        {selectedRelocatePins?.filter((item) => item.servico !== 'COLETA').map((item) =>
          item.oss?.map(
            ({ id_atendimento }, i) =>
              ((item.tipo !== "any" && i === 0) || item.tipo === "any") && (
                <S.TagArea key={i}>
                  <Tag
                    text={
                      item.tipo === "any"
                        ? id_atendimento?.toString()
                        : item.id_atendimento?.toString()
                    }
                    onClose={() => managePinRemoval(item)}
                  />
                </S.TagArea>
              )
          )
        )}
      </S.RealocateTags>
      {unassociatedPinAnyData?.unassociatedPin && (
        <>
          <Alert
            type="warning"
            description={unassociatedPinAnyData.unassociatedPin.status_pathway === "COLETA NO POLO" ? `O pin de coleta que você selecionou possui ${getTotalOss()} pins de entrega associados a ele. Selecione as entregas que deseja realocar.` : (`O pin de %b%${unassociatedPinAnyData?.unassociatedPin?.servico?.toLowerCase()}%b% que você selecionou possui %b%${unassociatedPinAnyData?.deliveriesPins2BeAssociated?.length
              }%b% pins de %b%entrega%b% associados a ele. Selecione as entregas que deseja realocar.`)}
            style={{
              wordBreak: 'normal',
              overflowWrap: 'break-word'
            }}
          />
          <S.DeliveriesArea>
            <S.DeliveryItem>
              <Checkbox
                label={`Selecionar todos (${checkedList?.length})`}
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                checked={checkAll}
                size={24}
              />
            </S.DeliveryItem>
            <CheckboxGroup
              onChange={onChange}
              value={checkedList}
              style={{ width: "100%" }}
            >
              {unassociatedPinAnyData.deliveriesPins2BeAssociated &&
                unassociatedPinAnyData.deliveriesPins2BeAssociated.map(
                  (item, i) => (
                    <S.DeliveryItem key={i * 0.1}>
                      <Checkbox
                        label={item.angel}
                        supportLabel={`${item?.id_atendimento} | Coleta/${true ? "Entrega" : "Polo"
                          }`}
                        size={24}
                        value={item.id}
                      />
                      {item.outro_polo ? (
                        <div style={{ width: 135 }}>
                          <Tag text="Entrega de outro polo" type="info" />
                        </div>
                      ) : (
                        <span
                          onClick={() =>
                            handleSeeOnMapClick(item.lat, item.lng)
                          }
                        >
                          Ver no mapa
                        </span>
                      )}
                    </S.DeliveryItem>
                  )
                )}
            </CheckboxGroup>
          </S.DeliveriesArea>
        </>
      )}

      <S.Footer>
        <Button
          size="small"
          onClick={() => {
            setNewWorkFlow(false);
            dispatch(resetSelectedRelocatePins());
            dispatch(resetSelectedPreDeliveryPins());
            dispatch(resetUnassociatedPinAnyData());
          }}
        >
          Cancelar
        </Button>
        <Button
          size="small"
          type="primary"
          disabled={
            !selectedRelocatePins.filter(pin => pin.servico !== 'COLETA').length || (!selectedAngel && !isDeallocate)
          }
          onClick={handleSaveClick}
        >
          Salvar
        </Button>
      </S.Footer>
    </S.RealocateContainer>
  );
};

export default RelocateRoutes;
